import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from '@emotion/styled'
import theme from '../constants/theme'
import Globe2 from '../assets/svgs/Globe2'
import ChevronDown from '../assets/svgs/ChevronDown'
import FlagEN from '../assets/svgs/FlagEN'
import FlagAR from '../assets/svgs/FlagAR'
import FlagGR from '../assets/svgs/FlagGR'

const locales = {
  en: { title: 'English', Flag: FlagEN },
  ar: { title: 'العربية', Flag: FlagAR },
  gr: { title: 'German', Flag: FlagGR },
}

const ToggleBtn = styled('button')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 12px',
  border: `1.5px solid ${theme.talentinoDisabledBlue}`,
  borderRadius: '20px',
  backgroundColor: 'transparent',
  color: theme.talentinoBlue,
  fontWeight: 600,
  fontSize: '0.875rem',
  cursor: 'pointer',
  outline: 'none',
  '&:focus': {
    outline: 'none',
    boxShadow: 'none',
  },
})

const Menu = styled('div')({
  position: 'absolute',
  top: 'calc(100% + 6px)',
  left: 0,
  minWidth: '160px',
  backgroundColor: theme.white,
  borderRadius: '10px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
  zIndex: 9999,
  overflow: 'hidden',
  padding: '4px 0',
})

const MenuItem = styled('button')(({ active }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  width: '100%',
  padding: '10px 16px',
  border: 'none',
  backgroundColor: active ? '#E5F3FF' : 'transparent',
  color: theme.talentinoBlue,
  fontWeight: active ? 600 : 400,
  fontSize: '0.875rem',
  cursor: 'pointer',
  textAlign: 'left',
  '&:hover': {
    backgroundColor: '#E5F3FF',
  },
}))

export default function LanguagesDropdown() {
  const { i18n } = useTranslation()
  const [menu, setMenu] = React.useState(false)
  const ref = React.useRef(null)

  const currentLocale = locales[i18n.language] || locales['en']

  useEffect(() => {
    const dir = i18n.dir(i18n.language)
    document.documentElement.dir = dir
  }, [i18n, i18n.language])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <ToggleBtn onClick={() => setMenu((v) => !v)}>
        <Globe2 width="16" height="16" color={theme.talentinoBlue} />
        {currentLocale.title}
        <ChevronDown
          width="12"
          height="12"
          color={theme.talentinoBlue}
          style={{
            transform: menu ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        />
      </ToggleBtn>

      {menu && (
        <Menu>
          {Object.keys(locales).map((locale) => {
            const { title, Flag } = locales[locale]
            return (
              <MenuItem
                key={locale}
                active={i18n.language === locale}
                onClick={() => {
                  i18n.changeLanguage(locale)
                  setMenu(false)
                }}
              >
                <Flag width="22" height="16" />
                {title}
              </MenuItem>
            )
          })}
        </Menu>
      )}
    </div>
  )
}
